import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider";
import { store } from "./redux/reducers/store";

import "antd/dist/antd.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </Provider>,
);
